/* src/app/modules/shared/components/column/column-quantity/column-quantity.component.scss */
app-column-quantity {
  display: contents;
}
/*# sourceMappingURL=column-quantity.component.css.map */
